import React, { Component } from 'react';
import AWS from 'aws-sdk';
import FormSubmitted from '../forms/components/FormSubmitted';
import Loading from '../../components/loading';
import { hostName, isLocal } from '../../constants';
import { getS3Region } from '../../utils/helpers';

const url = hostName.slice(6);
class CustomerResponse extends Component {
  constructor(props) {
    super(props);
    this.state={
        successMessage: '<p>Your response has been submitted successfully.</p><p>Someone from the Airport team will be reaching out to you soon.</p>',
        loadingStatus: false
      };
    const { match: { params: { id } } } = props;
    localStorage.setItem('portalBackendId', id);
    this.publicUrl = isLocal ? process.env.REACT_APP_BACKEND_PUBLICHOST : `https://apis.${id}${url}/public`;
    }

    componentDidMount = async () => {
      this.getConfig();
        const { match: { params: { airportCode, uniqueId, customerResponse } } } = this.props;
        const data = { 'unique_id': uniqueId, 'customer_response': customerResponse };
        this.setState({ loadingStatus: true });
        try {
            await fetch(`${this.publicUrl}/wait_list/get_customer_response/${airportCode}`, {
              method: 'POST',
              body: JSON.stringify(data),
              headers: { 'Content-Type': 'application/json' }
            })
            .then(response => response.json())
            .then((res) => {
              if (res.detail !== 'Response received already') {
                this.getData(res.detail, customerResponse);
              } else {
                this.setState({
                  successMessage: 'Your response has been already submitted.',
                  loadingStatus: false
                });
              }
            });
          } catch (error) {
            let message = 'There was a problem while submitting the response';
            if (error && error.detail) message = error.detail;
            this.setState({
              message,
              loadingStatus: false
            });
          }
    }

    getConfig = () => {
      AWS.config.update({
        region: process.env.REACT_APP_REGION
      });
      AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID
      });
      return AWS.config.credentials.getPromise();
    };

    getData = (fileName, customerResponse) => {
      const { match: { params: { id: code } } } = this.props;
      const s3 = new AWS.S3({
        apiVersion: '2006-03-01',
        region: getS3Region()
      });

      const params = {
        Bucket: `${process.env.REACT_APP_S3PREFIX}${isLocal? 'local' : code}-attachments/conditions/wait_list`,
        Key: `${fileName}`,
        ResponseCacheControl: 'no-cache'
      };

      new Promise((resolve, reject) => {
        s3.getObject(params, (err, data) => {
          if (err) {
            return reject(err);
          }
          return resolve(data);
        });
      }).then((response) => {
        const info = response.Body.toString();
        this.setState({ successMessage: info,
          loadingStatus: false
        });
      }).catch(() => {
        this.setState({ successMessage: customerResponse==='yes'
                      ? '<p>Your response has been submitted successfully.</p><p>Someone from the Airport team will be reaching out to you soon.</p>'
                      : '<p>Your response has been submitted successfully.</p>',
          loadingStatus: false
         });
      });
    };

    render() {
        const { message, loadingStatus, successMessage } = this.state;
        return (
        <div style={{ margin: '0px auto' }}>
            {loadingStatus && (
                <Loading loadingStatus={loadingStatus} />
            )}
            <FormSubmitted
              name=""
              message={message}
              successMessage={successMessage}
              fontStyle
            />
        </div>
        );
    }
}

export default CustomerResponse;
